import apiFetch from '../apiFetch'

export default function (token, dossierId, idx) {
  return apiFetch({ endPoint: `audit/GroupedDocuments/details?dossierId=${dossierId}&idx=${idx}`, method: 'GET', body: null, token: token })
}
